import React, { Component } from 'react'
import { cancelOrder } from '../../redux/actions/orderActions'
import dayjs from 'dayjs'
import 'dayjs/locale/nl'
import { connect } from 'react-redux'
import { Badge, Popconfirm } from 'antd';
dayjs.locale('nl')

export class CustOrders extends Component {

  handleCancleOrder=(id, status, updatedStatus)=>{
    this.props.cancelOrder(id, status, updatedStatus)
  }

  render() {
    const { clientOrders } = this.props.orders
    const orderList = clientOrders.sort((a, b) => b.date.toDate() - a.date.toDate()).map(x => { return(
      <div className="single-cust-order">
        <p>Order#: {x.orderNumber}</p>
    <p>Datum: {dayjs(x.date.toDate()).format('DD MMM YY') }</p>
    <p>Bedrag: {new Intl.NumberFormat('IN', { style: 'currency', currency: 'SRD'}).format(`${(x.orderCost)}`)}</p>
    <p>{x.status === 'pending' ? <span><Badge status="processing" />pending</span> : x.status === 'cancelled' ? <span><Badge status="error" />geannuleerd {x.updatedStatus === 'admin' ? 'door vendor' : null }</span> : x.status === 'processing' ?  <span><Badge status="warning" />in behandeling</span> : <span><Badge status="success" />afgewerkt</span>}</p>
     
     <div className="simple-link-button"><Popconfirm
      title="Bestelling annuleren?"
      onConfirm={()=>this.handleCancleOrder(x.id, x.status, x.updatedStatus)}
      okText="Ja, annuleer"
      cancelText="Nee"
     >Annuleren</Popconfirm></div>
      </div>
    )})
    return (
      <div className="cust-orders">
        <p className="cart-header">
          Uw bestellingen
        </p>
        {orderList.length > 0 ? orderList : <p className="empty-cart">Geen bestellingen</p>}
      </div>
    )
  }
}

const mapStateToProps=(state)=>({
  orders: state.order
})

export default connect(mapStateToProps, {cancelOrder})(CustOrders)
